// const API_URI = "http://localhost:8000/";
const API_URI = "https://analyticschat.com/";

export {
  API_URI
}